<h2 class="core-headline-sm" [ngClass]="{ subItem : isSubItem }">
    {{heading}}
</h2>

<!-- button goes here -->
<div id="action" [ngClass]="{ alwayShowContent : alwaysShowActions }">
    <ng-content>
    
    </ng-content>
</div>